export default "__VITE_ASSET__DbRoK51O__"